// ** Dropdowns Imports
import { Fragment, useContext } from 'react';

import UserDropdown from './UserDropdown';
import SolicitudesDropdown from './SolicitudesDropdown';

// ** Third Party Components
import { Sun, Moon, Menu} from 'react-feather';
import { Button, NavItem, NavLink } from 'reactstrap';
import logo_ijcf from '@src/assets/images/logo/logo_ijcf.png';
import { useHistory } from 'react-router-dom';

const NavbarUser = (props) => {
	// ** Props
	const { skin, setSkin, setMenuVisibility } = props;
	const history = useHistory();

	// ** Function to toggle Theme (Light/Dark)
	const ThemeToggler = () => {
		if (skin === 'dark') {
			return <Sun className="ficon" onClick={() => setSkin('light')} />;
		} else {
			return <Moon className="ficon" onClick={() => setSkin('dark')} />;
		}
	};

	return (
		<Fragment style={{ boxShadow: '0px 0px 22px #D3D5E380' }}>
			<img src={logo_ijcf} alt="logo" width={'200px'} />

			<ul className="navbar-nav d-xl-none d-flex align-items-center">
				<NavItem className="mobile-menu mr-auto">
					<NavLink
						className="nav-menu-main menu-toggle hidden-xs is-active"
						onClick={() => setMenuVisibility(true)}
					>
						<Menu className="ficon" />
					</NavLink>
				</NavItem>
			</ul>
			{/*<div className="bookmark-wrapper d-flex align-items-center">*/}
			{/*    <NavItem className="d-none d-lg-block">*/}
			{/*        <NavLink className="nav-link-style">*/}
			{/*            <ThemeToggler />*/}
			{/*        </NavLink>*/}
			{/*    </NavItem>*/}
			{/*</div>*/}
			<ul className="nav navbar-nav align-items-center ml-auto">
				<SolicitudesDropdown />
				<UserDropdown />
			</ul>
		</Fragment>
	);
};
export default NavbarUser;
